module.exports = __webpack_public_path__ + "static/media/heart-white.4e880860.svg";